<ng-container *ifIframe="false">
  <div
    *ngIf="showPageNameBar"
    class="page-name-bar"
    [class]="'page-name-bar ' + pageNameClass"
  >
    <div class="page-wrapper d-flex align-items-center h-100">
      <h1 class="page-name">{{ pageName }}</h1>
      <span
        *ngIf="pageNameClass === 'my-account-page'"
        class="vertical-tabs-page-name-toggle-anchor"
        aria-hidden="true"
      ></span>
    </div>
  </div>
</ng-container>
